import qwest from 'qwest';

import Product from '../models/product.jsx';

import session from './../services/sessionService.jsx';

let onSuccess = (type) => {
  if (type === 'list') {
    return (xhr, response) => {
      if (response.success) {
        let products = response.data.map(x => Product.fromApiFormat(x));

        session.setProducts(products);
        return products;
      }
      throw response;
    };
  }
  return (xhr, response) => {
    if (response.success) {
      return Product.fromApiFormat(response.data);
    }
    throw response;
  };
};

let onError = () => {
  throw {
    code: -1,
    data: null,
    message: 'Unexpected Error',
    success: false,
  };
};

let ProductApi = {
  getProduct(id) {
    return qwest.get(`/Product?id=${id}`)
      .then(onSuccess('single'), onError);
  },

  getProducts() {
    return new Promise((resolve, reject) => {
      let products = session.getProducts();

      if (products) {
        resolve(products);
      } else {
        qwest.get('/Product/All')
          .then((xhr, response) => {
            if (response.success) {
              let products = response.data.map(x => Product.fromApiFormat(x));

              session.setProducts(products);
              resolve(products);
            } else {
              reject(response);
            }
          });
      }
    });
  },

  deleteProduct(product) {
    return qwest.delete('/Product', product.toApiFormat())
      .then(onSuccess('single'), onError);
  },

  saveProduct(product) {
    return qwest.post('/Product', product.toApiFormat())
      .then(onSuccess('single'), onError);
  },

  getBranchSummaries(branchIDs, systemType, productType) {
    return qwest.post(`/Product/BranchSummaries?branchIDs=${branchIDs}&systemType=${systemType}&productType=${productType}`)
      .then((xhr, res) => {
        return res.data;
      })
      .catch(err => {
        console.error(err);
        throw err;
      });
  },
  getBranchSanitizerSummaries(branchIDs, systemType, productType) {
    return qwest.post(`/Product/BranchSanitizerSummaries?branchIDs=${branchIDs}&systemType=${systemType}&productType=${productType}`)
      .then((xhr, res) => {
        return res.data;
      })
      .catch(err => {
        throw err;
      });
  },

  updateProducts(branchIDs, systemType, productType, currentProduct, replacementProduct) {
    return qwest.post('/Product/UpdateProducts', {
      branchIDs,
      systemType,
      productType,
      currentProduct,
      replacementProduct,
    })
      .then((xhr, res) => {
        if (res.success) {
          return res.data;
        }
        throw res;
      })
      .catch(err => {
        console.error(err);
        return err;
      });
  },

  updateScalePreventionProducts(branchIDs, systemType, productType, sanitizerProduct, currentProduct, replacementProduct) {
    return qwest.post('/Product/UpdateScalePreventionProducts', {
      branchIDs,
      systemType,
      productType,
      sanitizerProduct,
      currentProduct,
      replacementProduct,
    })
      .then((xhr, res) => {
        if (res.success) {
          return res.data;
        }
        throw res;
      })
      .catch(err => {
        throw err;
      });
  },

  updateBalanceComplete(branchIDs, systemType, currentProduct, balanceComplete) {
    return qwest.post('/Product/UpdateBalanceComplete', {
      branchIDs,
      systemType,
      currentProduct,
      balanceComplete,
    })
      .then((xhr, res) => {
        if (res.success) {
          return res.data;
        }
        throw res;
      })
      .catch(err => {
        console.error(err);
        return err;
      });
  },
};

export default ProductApi;
